import React from "react";

import { cx } from "class-variance-authority";

import * as theme from "./Head.css";

interface TableHeadProps {
    children: React.ReactNode;
}
export function TableHead({ children }: TableHeadProps) {
    return <thead className={cx(theme.row, theme.head)}>{children}</thead>;
}
